export enum JobType {
  FULLTIME = 'FULLTIME',
  PARTTIME = 'PARTTIME',
}
